"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AppTools = function () {
    function AppTools() {
        _classCallCheck(this, AppTools);
    }

    _createClass(AppTools, null, [{
        key: "isMobileDevice",
        value: function isMobileDevice() {

            var check = false;
            (function (a) {
                if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
            })(navigator.userAgent || navigator.vendor || window.opera);
            return check;
        }
    }, {
        key: "getUrlParameterByName",
        value: function getUrlParameterByName(name, url) {

            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }
    }, {
        key: "clamp",
        value: function clamp(num, min, max) {

            return num <= min ? min : num >= max ? max : num;
        }
    }, {
        key: "hasFullScreenSupport",
        value: function hasFullScreenSupport() {

            var docEl = window.document.documentElement;
            var fs = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;

            if (fs != undefined) {
                return true;
            }

            return false;
        }
    }, {
        key: "disableFullScreen",
        value: function disableFullScreen() {

            var doc = window.document;
            var cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;

            cancelFullScreen.call(doc);
            viewer.isFullScreen = false;
        }
    }, {
        key: "enableFullScreen",
        value: function enableFullScreen() {

            var doc = window.document;
            var docEl = doc.documentElement;

            var requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;

            if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
                requestFullScreen.call(docEl);
                viewer.isFullScreen = true;
            }
        }
    }, {
        key: "toggleFullScreen",
        value: function toggleFullScreen() {

            if (!viewer.isFullScreen) {
                AppTools.enableFullScreen();
            } else {
                AppTools.disableFullScreen();
            }
        }
    }, {
        key: "browserIsEdge",
        value: function browserIsEdge() {

            return navigator.userAgent.includes("Edge");
        }
    }, {
        key: "rotateAroundObjectAxis",
        value: function rotateAroundObjectAxis(object, axisVector, radians) {

            var rotObjectMatrix = new THREE.Matrix4();
            rotObjectMatrix.makeRotationAxis(axisVector.normalize(), radians);
            object.matrix.multiply(rotObjectMatrix);
            object.rotation.setFromRotationMatrix(object.matrix);
        }
    }, {
        key: "rotateAroundWorldAxis",
        value: function rotateAroundWorldAxis(object, axisVector, radians) {

            var rotWorldMatrix = new THREE.Matrix4();
            rotWorldMatrix.makeRotationAxis(axisVector.normalize(), radians);
            rotWorldMatrix.multiply(object.matrix);
            object.matrix = rotWorldMatrix;
            object.rotation.setFromRotationMatrix(object.matrix);
        }
    }]);

    return AppTools;
}();
"use strict";

var overviewData = {
  "headline": "CPH Highline 360",
  "subtext": "Oplev Cph Highline i 3D. Klik på de fem hot spots og tag en tur rundt i byggeriet.",
  "poiCollections": [{
    "points": [{
      "x": 0.08789937674822801,
      "y": 0.26736441484300666,
      "headline": "K\xF8dbyen",
      "subtext": "600 m",
      "tintColor": "orange"
    }, {
      "x": 0.19145039981817052,
      "y": 0.20173745173745175,
      "headline": "R\xE5dhuspladsen",
      "subtext": "980 m",
      "tintColor": "orange"
    }, {
      "x": 0.23443997971720829,
      "y": 0.21122740247383445,
      "headline": "Str\xF8get",
      "subtext": "1.2 km",
      "tintColor": "orange"
    }, {
      "x": 0.2691719509545664,
      "y": 0.22835394862036157,
      "headline": "Tivoli",
      "subtext": "940 m",
      "tintColor": "orange"
    }, {
      "x": 0.30243920240067346,
      "y": 0.21693625118934348,
      "headline": "Kgs Nytorv",
      "subtext": "2 km",
      "tintColor": "orange"
    }, {
      "x": 0.3847416972819484,
      "y": 0.20923076923076922,
      "headline": "Christiansborg",
      "subtext": "1.5 km",
      "tintColor": "orange"
    }, {
      "x": 0.4436552901719034,
      "y": 0.21217887725975262,
      "headline": "Nyhavn",
      "subtext": "2 km",
      "tintColor": "orange"
    }, {
      "x": 0.6317170993672433,
      "y": 0.2274024738344434,
      "headline": "Christianshavn",
      "subtext": "2 km",
      "tintColor": "orange"
    }, {
      "x": 0.7912641216087771,
      "y": 0.21883920076117983,
      "headline": "Amager",
      "subtext": "2 km",
      "tintColor": "orange"
    }, {
      "x": 0.9147890188381901,
      "y": 0.7044989775051125,
      "headline": "Havnemilj\xF8",
      "subtext": "25 m",
      "tintColor": "orange"
    }],
    "layerName": "culture"
  }, {
    "points": [{
      "x": 0.14085540966243923,
      "y": 0.3263558515699334,
      "headline": "Dybb\xF8lsbro st.",
      "subtext": "530 m",
      "tintColor": "green"
    }, {
      "x": 0.1401764861635391,
      "y": 0.23977164605137963,
      "headline": "Hovedbaneg\xE5rden",
      "subtext": "920 m",
      "tintColor": "green"
    }, {
      "x": 0.06534096836336577,
      "y": 0.6355851569933397,
      "headline": "Bus",
      "subtext": "25 m",
      "tintColor": "green"
    }, {
      "x": 0.3058338198951742,
      "y": 0.3558515699333968,
      "headline": "Bus",
      "subtext": "100 m",
      "tintColor": "green"
    }, {
      "x": 0.5029367200122824,
      "y": 0.23596574690770694,
      "headline": "H.C.A. Boulevard",
      "subtext": "1 km",
      "tintColor": "green"
    }],
    "layerName": "transport"
  }]
};
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Overview = function () {
	function Overview() {
		_classCallCheck(this, Overview);

		this.bgImage = "images/cph_highline_main_bg.jpg";
		this.backgroundImageWidth = 3840;
		this.backgroundImageHeight = 2740;
		this.targetContainer = "ui-outer";
		this.rootContainer = "overview-outer";
		this.bgImageContainer = "overview-bg";
		this.visible = false;
		this.isAnimating = false;
		this.allPOICategoriesHiddenByDefault = true;

		this.initOverview();
	}

	_createClass(Overview, [{
		key: "initOverview",
		value: function initOverview() {
			var _this = this;

			var bgImage = new Image();
			bgImage.src = this.bgImage;

			bgImage.onload = function () {
				_this.addPageElements(bgImage.src);
			};
		}
	}, {
		key: "handleBrowserSpecificFixes",
		value: function handleBrowserSpecificFixes() {

			if (AppTools.browserIsEdge()) {

				$(".overview-hotspot-container").css("transition-property", "none");
				$(".overview-hotspot-image-container").css("transition-property", "none");
			}
		}
	}, {
		key: "addPageElements",
		value: function addPageElements(bgImageSrc) {

			// set up outer elements
			var target = $("#" + this.targetContainer);

			target.append($("<div>").addClass("overview-outer").attr("id", this.rootContainer).append($("<div>").addClass("overview-bg").attr("id", this.bgImageContainer).css("background-image", "url('" + bgImageSrc + "')")));

			// add additional overlays
			this.addLogo();
			this.parseOverviewData();
			this.populateHotspotsFromSceneData();
			this.handleBrowserSpecificFixes();

			this.show(false);
		}
	}, {
		key: "populateHotspotsFromSceneData",
		value: function populateHotspotsFromSceneData() {

			var scenes = sceneCollection.getAllScenes();

			for (var i = 0; i < scenes.length; i++) {
				this.addHotspot(scenes[i].overviewPosX, scenes[i].overviewPosY, scenes[i].overviewImage, scenes[i].name);
			}
		}
	}, {
		key: "placeOverview",
		value: function placeOverview() {

			var outer = $("#" + this.rootContainer);
			var container = $("#" + this.bgImageContainer);

			var containerWidth = parseInt(outer.width());
			var containerHeight = parseInt(outer.height());

			var minRatio = Math.min(containerWidth / this.backgroundImageWidth, containerHeight / this.backgroundImageHeight);
			var newImgWidth = minRatio * this.backgroundImageWidth;
			var newImgHeight = minRatio * this.backgroundImageHeight;

			var newImgX = (containerWidth - newImgWidth) / 2;
			var newImgY = (containerHeight - newImgHeight) / 2;

			container.css("left", newImgX);
			container.css("top", newImgY);

			container.css("width", newImgWidth);
			container.css("height", newImgHeight);
		}
	}, {
		key: "toggleVisibility",
		value: function toggleVisibility() {

			this.visible = !this.visible;
			this.show(this.visible);
		}
	}, {
		key: "show",
		value: function show(visible) {

			var container = $("#" + this.rootContainer);

			if (visible) {
				container.css("opacity", "0.0");
				container.css("display", "inline");
				container.animate({ opacity: 1.0, easing: "swing" }, 1000);
			} else {
				container.css("opacity", "1.0");
				container.animate({ opacity: 0.0, easing: "swing" }, 1000, function () {
					container.css("display", "none");
				});
			}

			this.placeOverview();
			this.visible = visible;
		}
	}, {
		key: "parseOverviewData",
		value: function parseOverviewData() {

			// handle basic text
			var headline = overviewData.headline;
			var subtext = overviewData.subtext;
			this.addDescription(headline, subtext);

			// handle POI data
			var poiLayers = [];

			for (var i = 0; i < overviewData.poiCollections.length; i++) {

				var layerName = overviewData.poiCollections[i].layerName;
				poiLayers.push(layerName);

				var points = overviewData.poiCollections[i].points;
				for (var j = 0; j < points.length; j++) {

					this.addPOI(points[j].x, points[j].y, points[j].headline, points[j].subtext, points[j].tintColor, layerName);
				}
			}

			this.addPOIMenu(poiLayers);
		}
	}, {
		key: "addLogo",
		value: function addLogo() {

			var container = $("#" + this.bgImageContainer);

			container.append($("<div>").addClass("overview-logo").addClass("scale"));
		}
	}, {
		key: "addDescription",
		value: function addDescription(headline, subtext) {

			var container = $("#" + this.bgImageContainer);

			container.append($("<div class='overview-description-container'>").append($("<div>").addClass("overview-headline").text(headline)).append($("<div>").addClass("overview-subtext").text(subtext)));
		}
	}, {
		key: "addHotspot",
		value: function addHotspot(normPosX, normPosY, thumbnailPath, sceneName) {

			var that = this;

			var container = $("#" + this.bgImageContainer);

			var finalRelPosX = normPosX * 100;
			var finalRelPosY = normPosY * 100;

			var hotspotContainer = container.append($("<div class='overview-hotspot-container visibility'>").css("left", finalRelPosX + "%").css("top", finalRelPosY + "%").click(function () {
				that.onHotspotSelected(sceneName);
			}).append($("<div>").addClass("overview-hotspot-outer")).append($("<div>").addClass("overview-hotspot-inner").text("+")).append($("<div><img src='" + thumbnailPath + "' class='overview-hotspot-image'></div>").addClass("overview-hotspot-image-container")));
		}
	}, {
		key: "addPOI",
		value: function addPOI(normPosX, normPosY, header, subtext, tintColor, layerName) {

			var container = $("#" + this.bgImageContainer);

			var finalRelPosX = normPosX * 100;
			var finalRelPosY = normPosY * 100;

			var chosenLayer = tintColor;

			container.append($("<div class='overview-poi-container'>").css("left", finalRelPosX + "%").css("top", finalRelPosY + "%").attr("data-options", "{\"tag\": \"" + layerName + "\" }").append($("<div>").addClass("overview-poi-label-header").text(header)).append($("<div>").addClass("overview-poi-label-sub").text(subtext)).append($("<div>").addClass("overview-poi-symbol").addClass(tintColor)));
		}
	}, {
		key: "addPOIMenu",
		value: function addPOIMenu(layers) {

			var that = this;

			var target = $("#" + this.bgImageContainer);
			var containerClass = "overview-poi-menu-container";

			target.append($("<div>").addClass(containerClass).addClass("visibility"));

			var container = $("." + containerClass);

			var _loop = function _loop(i) {

				container.append($("<div>").addClass("poi-menu-cell").addClass(layers[i]).click(function () {
					that.onTogglePOI($(this), layers[i]);
				}).append($("<div>").addClass("poi-menu-cell-inactive").addClass(layers[i])));
			};

			for (var i = 0; i < layers.length; i++) {
				_loop(i);
			}

			if (this.allPOICategoriesHiddenByDefault) {
				$(".poi-menu-cell-inactive").show();
				$(".overview-poi-container").css("opacity", "0.0");
			}
		}
	}, {
		key: "onTogglePOI",
		value: function onTogglePOI(element, layerName) {

			// skip if transition is in progress
			if (this.isAnimating) {
				return;
			} else {
				this.isAnimating = true;
			}

			var disabledOverlayTarget = element.children().first();
			var visible = !disabledOverlayTarget.is(":visible");
			var sourceClass = "overview-poi-container";
			var fadeDuration = 500;

			var finalState = !visible;
			var that = this;

			// handle poi visibility
			$("#" + this.bgImageContainer).find("." + sourceClass).each(function () {
				var tag = $(this).data("options").tag;

				if (tag === layerName) {

					if (finalState) {
						$(this).css("opacity", "0.0");
						$(this).show();
						$(this).animate({ opacity: 1.0 }, fadeDuration, function () {
							that.isAnimating = false;
						});
					} else {
						$(this).css("opacity", "1.0");
						$(this).animate({ opacity: 0.0 }, fadeDuration, function () {
							$(this).hide();
							that.isAnimating = false;
						});
					}
				}
			});

			// handle visibility of the selection layer
			if (finalState) {
				disabledOverlayTarget.hide();
			} else {
				disabledOverlayTarget.show();
			}
		}
	}, {
		key: "onHotspotSelected",
		value: function onHotspotSelected(sceneName) {

			this.show(false);
			viewer.loadScene(null, sceneName);
			viewerUI.selectActiveSceneByName(sceneName);
		}
	}, {
		key: "activateMousePosReporting",
		value: function activateMousePosReporting() {
			var _this2 = this;

			document.addEventListener('mouseup', function (e) {
				_this2.onMouseUp(e);
			}, false);
		}
	}, {
		key: "onMouseUp",
		value: function onMouseUp(event) {

			var element = $("#" + this.bgImageContainer);

			var x = event.pageX - element.offset().left;
			var y = event.pageY - element.offset().top;

			var relativePosX = x / element.innerWidth();
			var relativePosY = y / element.innerHeight();

			console.log("Absolute (x,y): " + x + ", " + y);
			console.log("Relative (x,y): " + relativePosX + ", " + relativePosY);
		}
	}]);

	return Overview;
}();

"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var POIVisibilityTag = function POIVisibilityTag(tagName, visible) {
	_classCallCheck(this, POIVisibilityTag);

	this.tagName = tagName;
	this.visible = visible;
};

var POIVisibilityState = function () {
	function POIVisibilityState() {
		_classCallCheck(this, POIVisibilityState);

		this.tags = [];
	}

	_createClass(POIVisibilityState, [{
		key: "setTagState",
		value: function setTagState(tagName, visible) {

			var isPresent = false;
			for (var i = 0; i < this.tags.length; i++) {
				if (this.tags[i].tagName.toLowerCase() === tagName.toLowerCase()) {
					this.tags[i].visible = visible;
					isPresent = true;
					break;
				}
			}
			if (!isPresent) {
				this.tags.push(new POIVisibilityTag(tagName.toLowerCase(), visible));
			}
		}
	}, {
		key: "getAllTags",
		value: function getAllTags() {

			return this.tags;
		}
	}, {
		key: "getDisabledTags",
		value: function getDisabledTags() {

			var disabledTags = [];
			for (var i = 0; i < this.tags.length; i++) {
				if (!this.tags[i].visible) {
					disabledTags.push(this.tags[i].tagName);
				}
			}
			return disabledTags;
		}
	}, {
		key: "isVisible",
		value: function isVisible(tagName) {

			for (var i = 0; i < this.tags.length; i++) {
				if (this.tags[i].tagName.toLowerCase() === tagName.toLowerCase()) {
					return this.tags[i].visible;
				}
			}

			return null;
		}
	}]);

	return POIVisibilityState;
}();
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PortalController = function () {
	function PortalController() {
		var _this = this;

		_classCallCheck(this, PortalController);

		this.spriteImagSrc = "textures/portal_spot_sprite_256.png";
		this.highlightScaleFactor = 1.5;
		this.highlightOpacity = 0.75;
		this.defaultOpacity = 1.0;
		this.pulseMinOpacity = 0.5;
		this.pulseMaxOpacity = 1.0;

		this.mousePos = { "x": 0, "y": 0 };
		this.previousMousePos = { "x": null, "y": null };
		this.isHovering = false;
		this.previouslyHoveredPortal = null;
		this.raycaster = new THREE.Raycaster();
		this.mouseDown = false;
		this.lastMouseDragDistance = 0.0;
		this.mouseDragLimit = 0.025;
		this.hoverTrackingTimeoutInSeconds = 1.0;
		this.lastCreationTime = null;
		this.visibilityDelayInSeconds = 1.0;
		this.isNavigating = false;

		document.addEventListener('mousedown', function (e) {
			_this.onMouseDown(e);
		}, false);
		document.addEventListener('mouseup', function (e) {
			_this.onMouseUp(e);
		}, false);
		document.addEventListener('mousemove', function (e) {
			_this.onMouseMove(e);
		}, false);
		document.addEventListener('touchstart', function (e) {
			_this.onTouchStart(e);
		}, false);
		document.addEventListener('touchend', function (e) {
			_this.onTouchEnd(e);
		}, false);
		document.addEventListener('touchcancel', function (e) {
			_this.onTouchCancel(e);
		}, false);
	}

	_createClass(PortalController, [{
		key: "onVRModeActivated",
		value: function onVRModeActivated(visible) {
			var _this2 = this;

			var baseClass = "cardboard-clickable-area";

			if (visible) {
				$("#ui-outer").append($("<div>").addClass(baseClass).on('click', function (event) {
					_this2.onVRButtonEvent(event);
				}));
			} else {
				$("." + baseClass).remove();
			}
		}
	}, {
		key: "onVRButtonEvent",
		value: function onVRButtonEvent(event) {

			this.initiateNavigationEffect();
		}
	}, {
		key: "onTouchStart",
		value: function onTouchStart(event) {

			var clickedPortal = this.setTouchMousePosAndGetPortalIntersection();

			if (clickedPortal != null) {
				this.onPortalHoverBegin(clickedPortal);
				this.previouslyHoveredPortal = clickedPortal;
			}
		}
	}, {
		key: "onTouchCancel",
		value: function onTouchCancel(event) {

			this.onPortalHoverBegin(this.previouslyHoveredPortal);
		}
	}, {
		key: "onTouchEnd",
		value: function onTouchEnd(event) {

			var clickedPortal = this.setTouchMousePosAndGetPortalIntersection();

			if (clickedPortal != null) {
				this.initiateNavigationEffect();
			} else {
				this.onPortalHoverEnd(this.previouslyHoveredPortal);
			}
		}
	}, {
		key: "onMouseDown",
		value: function onMouseDown(event) {

			// skip this event type on mobile
			if (viewer.isMobile) return;

			this.mouseDown = true;
		}
	}, {
		key: "onMouseMove",
		value: function onMouseMove(event) {

			// skip this event type on mobile
			if (viewer.isMobile) return;

			this.mousePos.x = event.clientX / window.innerWidth * 2 - 1;
			this.mousePos.y = -(event.clientY / window.innerHeight) * 2 + 1;

			var hoveredPortal = this.getPortalIntersection(new THREE.Vector2(this.mousePos.x, this.mousePos.y));

			if (!this.isHovering && hoveredPortal != null) {
				this.onPortalHoverBegin(hoveredPortal);
				this.previouslyHoveredPortal = hoveredPortal;
				this.isHovering = true;
			}

			if (this.isHovering && hoveredPortal === null) {
				this.onPortalHoverEnd(this.previouslyHoveredPortal);
				this.isHovering = false;
			}

			if (this.mouseDown) {

				if (this.previousMousePos.x) {
					this.lastMouseDragDistance += Math.sqrt(Math.pow(this.previousMousePos.y - this.mousePos.y, 2) + Math.pow(this.previousMousePos.x - this.mousePos.x, 2));
				}
			}

			this.previousMousePos.x = this.mousePos.x;
			this.previousMousePos.y = this.mousePos.y;
		}
	}, {
		key: "onMouseUp",
		value: function onMouseUp(event) {

			// skip this event type on mobile
			if (viewer.isMobile) return;

			this.mouseDown = false;

			var clickedPortal = this.getPortalIntersection(new THREE.Vector2(this.mousePos.x, this.mousePos.y));

			if (clickedPortal != null) {

				if (this.lastMouseDragDistance < this.mouseDragLimit) {
					this.initiateNavigationEffect(clickedPortal);
				}
			}

			this.lastMouseDragDistance = 0.0;
		}
	}, {
		key: "onPortalHoverBegin",
		value: function onPortalHoverBegin(portal) {

			if (this.isWithinHoverTrackingTimeout()) {
				return;
			}

			this.highlightHoveredPortal(portal, true);
		}
	}, {
		key: "onPortalHoverEnd",
		value: function onPortalHoverEnd(portal) {

			if (this.isWithinHoverTrackingTimeout() || portal === null) {
				return;
			}

			this.highlightHoveredPortal(portal, false);
		}
	}, {
		key: "isWithinHoverTrackingTimeout",
		value: function isWithinHoverTrackingTimeout() {

			// hack to avoid gettings false hover events while loading a new scene
			return this.lastCreationTime != null && viewer.clock.getElapsedTime() - this.lastCreationTime < this.hoverTrackingTimeoutInSeconds;
		}
	}, {
		key: "highlightHoveredPortal",
		value: function highlightHoveredPortal(portal, active) {
			var scaleEffect = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;


			this.previouslyHoveredPortal = portal;

			if (portal === null) return;

			if (scaleEffect) {

				var finalScale = active ? portal.meta.defaultScale * this.highlightScaleFactor : portal.meta.defaultScale;
				var finalScaleVec = new THREE.Vector3(finalScale, finalScale, finalScale);
				TweenHelpers.animateVector3(portal.scale, finalScaleVec, { duration: 500.0, easing: TWEEN.Easing.Sinusoidal.InOut });
			} else {

				var opacity = active ? this.highlightOpacity : this.defaultOpacity;
				portal.material.opacity = opacity;
			}
		}
	}, {
		key: "showAllPortals",
		value: function showAllPortals(visible) {

			var opacity = visible ? this.defaultOpacity : 0.0;

			viewer.scene.traverse(function (object) {

				if (object instanceof THREE.Sprite) {
					if (object.meta != undefined) {
						if (object.meta.type === "portal") {
							object.material.opacity = opacity;
						}
					}
				}
			});
		}
	}, {
		key: "setTouchMousePosAndGetPortalIntersection",
		value: function setTouchMousePosAndGetPortalIntersection() {

			this.mousePos.x = event.changedTouches[0].clientX / window.innerWidth * 2 - 1;
			this.mousePos.y = -(event.changedTouches[0].clientY / window.innerHeight) * 2 + 1;

			var clickedPortal = this.getPortalIntersection(new THREE.Vector2(this.mousePos.x, this.mousePos.y));

			return clickedPortal;
		}
	}, {
		key: "createPortalSprite",
		value: function createPortalSprite(cameraPos, intersectionPos, spriteScale, spriteDistPercentage) {
			var visible = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;


			// calculate positioning
			var startPos = cameraPos;
			var direction = new THREE.Vector3();
			direction.subVectors(intersectionPos, startPos);

			var finalPos = new THREE.Vector3();
			finalPos.addVectors(startPos, direction.multiplyScalar(spriteDistPercentage));

			var canvas = document.createElement('canvas');
			var context = canvas.getContext('2d');
			context.canvas.width = 256;
			context.canvas.height = 256;

			// canvas contents will be used as a texture
			var texture = new THREE.Texture(canvas);
			texture.needsUpdate = true;

			// create the sprite and position it
			var spriteMaterial = new THREE.SpriteMaterial({ map: texture, color: 0xffffff });
			var sprite = new THREE.Sprite(spriteMaterial);
			sprite.scale.set(spriteScale, spriteScale, spriteScale);
			sprite.position.set(finalPos.x, finalPos.y, finalPos.z);

			// fit the image into the texture size and add the sprite to the scene
			var spriteImage = new Image();
			spriteImage.src = this.spriteImagSrc;

			spriteImage.onload = function () {
				context.drawImage(spriteImage, 0, 0, spriteImage.width, spriteImage.height);
				viewer.scene.add(sprite);
			};

			if (!visible) {
				sprite.material.opacity = 0.0;
			}

			this.lastCreationTime = viewer.clock.getElapsedTime();
			return sprite;
		}
	}, {
		key: "addPortalSpriteMetaData",
		value: function addPortalSpriteMetaData(sprite, linkedSceneName, defaultScale) {

			sprite.meta = {};
			sprite.meta.linkedSceneName = linkedSceneName;
			sprite.meta.defaultScale = defaultScale;
			sprite.meta.type = "portal";
		}
	}, {
		key: "insertPortalFromJSON",
		value: function insertPortalFromJSON(jsonObject) {
			var visible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;


			var dataset = jsonObject.dataset;

			for (var i = 0; i < dataset.length; i++) {

				var intersectionPoint = new THREE.Vector3(dataset[i].intersectionPoint.x, dataset[i].intersectionPoint.y, dataset[i].intersectionPoint.z);
				var linkedSceneName = dataset[i].linkedSceneName;
				var spriteScale = dataset[i].scale;
				var spriteDistPercentage = dataset[i].distPercentage;
				var hoverImage = dataset[i].previewImage;

				var sprite = this.createPortalSprite(viewer.camera.position, intersectionPoint, spriteScale, spriteDistPercentage, visible);
				this.addPortalSpriteMetaData(sprite, linkedSceneName, spriteScale);
				this.addPortalPulseEffect(sprite);
			}
		}
	}, {
		key: "getPortalIntersection",
		value: function getPortalIntersection(mousePos) {

			this.raycaster.setFromCamera(mousePos, viewer.camera);
			var intersects = this.raycaster.intersectObjects(viewer.scene.children);

			for (var i = 0; i < intersects.length; i++) {

				if (intersects[i].object.type === "Sprite" && intersects[i].object.meta.linkedSceneName != null) {
					return intersects[i].object;
				}
			}

			return null;
		}
	}, {
		key: "getFirstPortal",
		value: function getFirstPortal() {

			var target = null;

			viewer.scene.traverse(function (object) {

				if (object instanceof THREE.Sprite) {
					if (object.meta != undefined) {
						if (object.meta.type === "portal") {
							target = object;
						}
					}
				}
			});

			return target;
		}
	}, {
		key: "cancelNavigattionEffect",
		value: function cancelNavigattionEffect() {

			if (viewer.isMobile) {
				viewer.deviceOrientationControls.connect();
			}

			this.isNavigating = false;
		}
	}, {
		key: "initiateNavigationEffect",
		value: function initiateNavigationEffect() {
			var portal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;


			if (this.isNavigating) {
				return;
			} else {
				this.isNavigating = true;
			}

			if (portal === null) {
				portal = this.getFirstPortal();
				if (portal === null) {
					this.cancelNavigattionEffect();
					return;
				}
			}

			if (viewer.isMobile) {
				viewer.deviceOrientationControls.disconnect();
			}

			this.initiateCameraLookatEffectWithSlerp(portal);
		}
	}, {
		key: "initiateCameraLookatEffect",
		value: function initiateCameraLookatEffect(portal) {

			var target = portal;
			var that = this;

			// release the camera lookat operation in the normal update loop
			viewer.manualCameraControl = true;

			// backup original rotation
			var origRot = new THREE.Euler().copy(viewer.camera.rotation);

			// simulate rotation with lookat
			viewer.camera.lookAt(target.position);
			var finalRot = new THREE.Euler().copy(viewer.camera.rotation);

			// restore original rotation
			viewer.camera.rotation.copy(origRot);

			// Perform the tweened rotation
			var tween = new TWEEN.Tween(viewer.camera.rotation).to({
				x: finalRot.x,
				y: finalRot.y,
				z: finalRot.z
			}, 500).easing(TWEEN.Easing.Linear.None).onComplete(function () {
				that.initiateCameraFOVEffect(portal);
			}).start();
		}
	}, {
		key: "initiateCameraLookatEffectWithSlerp",
		value: function initiateCameraLookatEffectWithSlerp(portal) {

			var target = portal;
			var that = this;

			// release the camera lookat operation in the normal update loop
			viewer.manualCameraControl = true;

			// backup original rotation
			var origRot = new THREE.Euler().copy(viewer.camera.rotation);

			// simulate rotation with lookat
			viewer.camera.lookAt(target.position);
			var finalRot = new THREE.Euler().copy(viewer.camera.rotation);

			// restore original rotation
			viewer.camera.rotation.copy(origRot);

			// Perform the tweened rotation
			var qSrc = new THREE.Quaternion().copy(viewer.camera.quaternion);
			var qDest = new THREE.Quaternion().setFromEuler(finalRot);
			var qValue = new THREE.Quaternion();

			var valueObj = { t: 0 };
			var tween = new TWEEN.Tween(valueObj).to({
				t: 1
			}, 500).easing(TWEEN.Easing.Linear.None).onUpdate(function () {
				THREE.Quaternion.slerp(qSrc, qDest, qValue, valueObj.t);
				viewer.camera.quaternion.set(qValue.x, qValue.y, qValue.z, qValue.w);
			}).onComplete(function () {
				that.initiateCameraFOVEffect(portal);
			}).start();
		}
	}, {
		key: "initiateCameraFOVEffect",
		value: function initiateCameraFOVEffect(portal) {

			var fovTarget = 10.0;
			var animTime = 500.0;
			var that = this;

			TweenHelpers.animateFloat(viewer.camera.fov, fovTarget, { duration: animTime, easing: TWEEN.Easing.Sinusoidal.InOut, update: function update(result) {
					viewer.setFov(result.value);
				}, callback: function callback() {
					that.endNavigationEffect(portal);
				} });
		}
	}, {
		key: "endNavigationEffect",
		value: function endNavigationEffect(portal) {

			viewer.setDefaultFov();
			this.navigateThroughPortal(portal);
			viewer.manualCameraControl = false;

			if (viewer.isMobile) {
				viewer.deviceOrientationControls.connect();
			}

			this.isNavigating = false;
		}
	}, {
		key: "navigateThroughPortal",
		value: function navigateThroughPortal() {
			var portal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;


			if (portal === null) {
				portal = this.getFirstPortal();
			}

			if (portal != null) {
				viewer.loadScene(null, portal.meta.linkedSceneName);
				viewerUI.selectActiveSceneByName(portal.meta.linkedSceneName);
			}
		}
	}, {
		key: "addPortalPulseEffect",
		value: function addPortalPulseEffect(portal) {

			var fadeTime = 1000;
			var fadeUpValue = { o: this.pulseMinOpacity };
			var fadeDownValue = { o: this.pulseMaxOpacity };

			var fadeUpTween = new TWEEN.Tween(fadeUpValue).to({ o: this.pulseMaxOpacity }, fadeTime).easing(TWEEN.Easing.Cubic.InOut).onUpdate(function () {
				portal.material.opacity = fadeUpValue.o;
			});

			var fadeDownTween = new TWEEN.Tween(fadeDownValue).to({ o: this.pulseMinOpacity }, fadeTime).easing(TWEEN.Easing.Cubic.InOut).onUpdate(function () {
				portal.material.opacity = fadeDownValue.o;
			});

			fadeUpTween.onComplete(function () {
				fadeUpValue.o = this.pulseMinOpacity;
				fadeDownTween.start();
			});

			fadeDownTween.onComplete(function () {
				fadeDownValue.o = this.pulseMaxOpacity;
				fadeUpTween.start();
			});

			fadeUpTween.start();
		}
	}, {
		key: "updatePortalData",
		value: function updatePortalData() {

			var activeScene = sceneCollection.getActiveScene();
			if (activeScene.portalData != null) {
				this.insertPortalFromJSON(activeScene.portalData);
			}

			var that = this;
			setTimeout(function () {
				that.showAllPortals(true);
			}, this.visibilityDelayInSeconds * 1e3);
		}
	}]);

	return PortalController;
}();

"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SceneCollection = function () {
	function SceneCollection() {
		_classCallCheck(this, SceneCollection);

		this.scenes = [];
		this.activeScene = null;
	}

	_createClass(SceneCollection, [{
		key: "getActiveScene",
		value: function getActiveScene() {

			return this.activeScene;
		}
	}, {
		key: "getActiveSceneName",
		value: function getActiveSceneName() {

			return this.activeScene.name;
		}
	}, {
		key: "setActiveScene",
		value: function setActiveScene(name) {

			if (!this.isValidScene(name)) {
				return false;
			}

			this.activeScene = this.getSceneByName(name);
			return true;
		}
	}, {
		key: "addScene",
		value: function addScene(scene) {

			this.scenes.push(scene);
		}
	}, {
		key: "getAllScenes",
		value: function getAllScenes() {

			return this.scenes;
		}
	}, {
		key: "getDefaultScene",
		value: function getDefaultScene() {

			for (var i = 0; i < this.scenes.length; i++) {
				if (this.scenes[i].isDefault) {
					return this.scenes[i];
				}
			}

			return null;
		}
	}, {
		key: "getSceneByName",
		value: function getSceneByName(name) {

			for (var i = 0; i < this.scenes.length; i++) {
				if (this.scenes[i].name.toLowerCase() === name.toLowerCase()) {
					return this.scenes[i];
				}
			}

			return null;
		}
	}, {
		key: "isValidScene",
		value: function isValidScene(name) {

			for (var i = 0; i < this.scenes.length; i++) {

				if (this.scenes[i].name.toLowerCase() === name.toLowerCase()) {
					return true;
				}
			}

			return false;
		}
	}]);

	return SceneCollection;
}();

var Scene = function Scene(name, isDefault, leftEyeImage, rightEyeImage, headline, description, previewImage, poiData, oPosX, oPosY, oImage, portalData) {
	var startLat = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : 0;
	var startLon = arguments.length > 13 && arguments[13] !== undefined ? arguments[13] : 0;

	_classCallCheck(this, Scene);

	this.name = name;
	this.isDefault = isDefault;
	this.leftEyeImage = leftEyeImage;
	this.rightEyeImage = rightEyeImage;
	this.headline = headline;
	this.description = description;
	this.previewImage = previewImage;
	this.poiData = poiData;
	this.overviewPosX = oPosX;
	this.overviewPosY = oPosY;
	this.overviewImage = oImage;
	this.portalData = portalData;
	this.startLat = startLat;
	this.startLon = startLon;
};
"use strict";

/* eslint key-spacing: 0 */
/* eslint comma-spacing: 0 */
/* global SceneCollection */
/* global Scene */

// The main collection of scene data

var sceneCollection = new SceneCollection();

// Add the defined scenes

sceneCollection.addScene(new Scene("HOVED- INDGANG", true, "textures/skanska_cph_highline_r2_view06_exterior_entrance_left.jpg", "textures/skanska_cph_highline_r2_view06_exterior_entrance_left.jpg", "Cph Highline hovedindgang", "Velkommen til Cph Highline. Et kontor med kant, charme og sjæl.\nTæt på city og lige ved vandet.", "images/skanska_cph_highline_r2_view06_exterior_entrance_preview.png", null, 0.17809068130930802, 0.6758620689655173, "images/skanska_cph_highline_r2_view06_exterior_entrance_overview_thumbnail.png", { "dataset": [{ "intersectionPoint": { "x": -479.04404780957054, "y": 12.387539091586001, "z": 139.5094845123618 }, "scale": 50, "distPercentage": 0.75, "linkedSceneName": "indgang/ foyer" }] }, 7.2, 166.6));

sceneCollection.addScene(new Scene("INDGANG/ FOYER", true, "textures/skanska_cph_highline_entrance_lobby_left.jpg", "textures/skanska_cph_highline_entrance_lobby_right.jpg", "Indgang og foyer", "Du og dine gæster bliver budt velkommen i et lyst, åbent og venligt receptionsmiljø,\nder også fungerer som lounge- og opholdsområde.", "images/skanska_cph_highline_entrance_lobby_preview.png", null, 0.24723258392073028, 0.6477732793522267, "images/skanska_cph_highline_entrance_lobby_thumbnail.png", { "dataset": [{ "intersectionPoint": { "x": -411.9496275103309, "y": -23.71316718105125, "z": 280.72597197860944 }, "scale": 50, "distPercentage": 0.75, "linkedSceneName": "foyer/ atrium" }] }, -1.8, -77.8));

sceneCollection.addScene(new Scene("FOYER/ ATRIUM", true, "textures/skanska_cph_highline_lobby_second_floor_left.jpg", "textures/skanska_cph_highline_lobby_second_floor_right.jpg", "Foyer/atrium", "Fra de fleksible arbejdsstationer på 1. sal kan du lade dig inspirere af\net panorama view mod atrium-området og det grønne gårdrum.", "images/skanska_cph_highline_lobby_second_floor_preview.png", null, 0.19974383167685664, 0.6253807106598985, "images/skanska_cph_highline_lobby_second_floor_thumbnail.png", { "dataset": [{ "intersectionPoint": { "x": -463.80307548127917, "y": -16.083186812315972, "z": -183.29276915557 }, "scale": 50, "distPercentage": 0.75, "linkedSceneName": "kontor" }] }, -9.5, -147.5));

/*sceneCollection.addScene(

	new Scene(
		"RECEPTION",
		true,
		"textures/skanska_cph_highline_r2_view04_interior_lobby_left.jpg",
		"textures/skanska_cph_highline_r2_view04_interior_lobby_right.jpg",
		"Reception",
		"Receptionen med loungeområdet er hjertet i huset.\nHer har du højt til loftet og kan nyde\net panorama view mod det grønne gårdrum.",
		"images/skanska_cph_highline_r2_view04_interior_lobby_preview.png",
		null,
		0.24723258392073028,
		0.6477732793522267,
		"images/skanska_cph_highline_r2_view04_interior_lobby_overview_thumbnail.png",
		{"dataset":[{"intersectionPoint":{"x":-88.89077620292345,"y":8.53348952346643,"z":491.1208717548387},"scale":50,"distPercentage":0.75,"linkedSceneName":"kontor"}]},
		-1.8,
		-77.8
	)
);*/

sceneCollection.addScene(new Scene("KONTOR", false, "textures/skanska_cph_highline_r2_view03_interior_vip_meeting_left.jpg", "textures/skanska_cph_highline_r2_view03_interior_vip_meeting_right.jpg", "Kontor med udsigt", "Dobbelthøjt rum med udsigt ud over København.\nRummet kan bruges til f.eks. åben arbejdszone og møderum.", "images/skanska_cph_highline_r2_view03_interior_vip_meeting_preview.png", null, 0.1970414163282561, 0.5161579892280072, "images/skanska_cph_highline_r2_view03_interior_vip_meeting_overview_thumbnail.png", { "dataset": [{ "intersectionPoint": { "x": 327.92030355228906, "y": -24.443825667468683, "z": -375.7193061144608 }, "scale": 50, "distPercentage": 0.75, "linkedSceneName": "taghave" }] }, -5.4, 271.9));

sceneCollection.addScene(new Scene("TAGHAVE", false, "textures/skanska_cph_highline_r2_view02_exterior_urban_farming_left.jpg", "textures/skanska_cph_highline_r2_view02_exterior_urban_farming_right.jpg", "Taghave med café, arbejdszone og\nUrban Gardening", "Café, bar og event område. Her kan du holde møder, arrangementer og netværke for åben himmel. Plantekasserne leverer grønt til kantinen og skaber et anderledes miljø.", "images/skanska_cph_highline_r2_view02_exterior_urban_farming_preview.png", null, 0.35267515383059855, 0.5404858299595142, "images/skanska_cph_highline_r2_view02_exterior_urban_farming_overview_thumbnail.png", { "dataset": [{ "intersectionPoint": { "x": 308.09844636191065, "y": 7.096141416141139, "z": -392.6465874522701 }, "scale": 50, "distPercentage": 0.75, "linkedSceneName": "café" }] }, -5.1, 407.4));

sceneCollection.addScene(new Scene("CAFÉ", false, "textures/skanska_cph_highline_r2_view01_exterior_cafe_left.jpg", "textures/skanska_cph_highline_r2_view01_exterior_cafe_right.jpg", "Café med udsigt over havnen", "Caféområde med udsigt over havneløbet og det maritime miljø\nomkring husbådhavnen. Tag et møde eller en kaffepause i solen.", "images/skanska_cph_highline_r2_view01_exterior_cafe_preview.png", null, 0.6112261129246591, 0.7560728744939271, "images/skanska_cph_highline_r2_view01_exterior_cafe_overview_thumbnail.png", { "dataset": [{ "intersectionPoint": { "x": -492.88547099736707, "y": -34.40212904037095, "z": 71.26131433016243 }, "scale": 50, "distPercentage": 0.75, "linkedSceneName": "hoved- indgang" }] }, -0.8, 179.9));
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TweenHelpers = function () {
	function TweenHelpers() {
		_classCallCheck(this, TweenHelpers);
	}

	_createClass(TweenHelpers, null, [{
		key: "animateVector3",
		value: function animateVector3(vectorToAnimate, target, options) {

			options = options || {};
			// get targets from options or set to defaults
			var to = target || THREE.Vector3(),
			    easing = options.easing || TWEEN.Easing.Quadratic.In,
			    duration = options.duration || 2000;
			// create the tween
			var tweenVector3 = new TWEEN.Tween(vectorToAnimate).to({ x: to.x, y: to.y, z: to.z }, duration).easing(easing).onUpdate(function (d) {
				if (options.update) {
					options.update(d);
				}
			}).onComplete(function () {
				if (options.callback) options.callback();
			});
			// start the tween
			tweenVector3.start();
			// return the tween in case we want to manipulate it later on
			return tweenVector3;
		}
	}, {
		key: "animateFloat",
		value: function animateFloat(floatToAnimate, target, options) {

			options = options || {};
			// get targets from options or set to defaults
			var to = target || 1.0,
			    easing = options.easing || TWEEN.Easing.Quadratic.In,
			    duration = options.duration || 2000;
			// create the tween
			var tweenFloat = new TWEEN.Tween({ value: floatToAnimate }).to({ value: target }, duration).easing(easing).onUpdate(function (d) {
				if (options.update) {
					options.update(d);
				}
			}).onComplete(function () {
				if (options.callback) options.callback();
			});
			// start the tween
			tweenFloat.start();
			// return the tween in case we want to manipulate it later on
			return tweenFloat;
		}
	}, {
		key: "trackOriginalOpacities",
		value: function trackOriginalOpacities(mesh) {

			var opacities = [],
			    materials = mesh.material.materials ? mesh.material.materials : [mesh.material];
			for (var i = 0; i < materials.length; i++) {
				materials[i].transparent = true;
				opacities.push(materials[i].opacity);
			}
			mesh.userData.originalOpacities = opacities;
		}
	}, {
		key: "fadeMesh",
		value: function fadeMesh(mesh, direction, options) {

			options = options || {};
			// set and check 
			var current = { percentage: direction == "out" ? 1 : 0 },

			// this check is used to work with normal and multi materials.
			mats = mesh.material.materials ? mesh.material.materials : [mesh.material],
			    originals = mesh.userData.originalOpacities,
			    easing = options.easing || TWEEN.Easing.Linear.None,
			    duration = options.duration || 2000;
			// check to make sure originals exist
			if (!originals) {
				console.error("Fade error: originalOpacities not defined, use trackOriginalOpacities");
				return;
			}
			// tween opacity back to originals
			var tweenOpacity = new TWEEN.Tween(current).to({ percentage: direction == "out" ? 0 : 1 }, duration).easing(easing).onUpdate(function () {
				for (var i = 0; i < mats.length; i++) {
					mats[i].opacity = originals[i] * current.percentage;
				}
			}).onComplete(function () {
				if (options.callback) {
					options.callback();
				}
			});
			tweenOpacity.start();
			return tweenOpacity;
		}
	}]);

	return TweenHelpers;
}();
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

$(document).ready(function () {

	viewerUI.init();
});

var ViewerUI = function () {
	function ViewerUI() {
		_classCallCheck(this, ViewerUI);
	}

	_createClass(ViewerUI, [{
		key: "init",
		value: function init() {

			$("#vr-icon").click(this.onActivateVR);
			$("#fullscreen-icon").click(this.onToggleFullScreen);
			$("#poi-transport").click(this.onTogglePOI);
			$("#poi-culture").click(this.onTogglePOI);
		}
	}, {
		key: "onActivateVR",
		value: function onActivateVR() {

			viewer.isStereoMode = !viewer.isStereoMode;
			if (viewer.isStereoMode) {
				$(this).addClass("vr-selected");
				viewer.switchRenderMode(viewer.DisplayMode.stereo);

				if (AppTools.hasFullScreenSupport()) {
					AppTools.enableFullScreen();
				}
			} else {
				$(this).removeClass("vr-selected");
				viewer.switchRenderMode(viewer.DisplayMode.normal);

				if (AppTools.hasFullScreenSupport()) {
					AppTools.disableFullScreen();
				}
			}

			viewer.portalController.onVRModeActivated(viewer.isStereoMode);
		}
	}, {
		key: "onToggleFullScreen",
		value: function onToggleFullScreen() {

			AppTools.toggleFullScreen();
		}
	}, {
		key: "onTogglePOI",
		value: function onTogglePOI(event) {

			var target = $(event.target);
			var tag = $(target).data("options").tag;

			var visible = !viewer.poiVisibilityState.isVisible(tag);

			viewer.togglePOIByCategory(tag, visible);
			viewer.poiVisibilityState.setTagState(tag, visible);

			if (visible) {
				$(target).children('.poi-menu-cell-inactive').hide();
			} else {
				$(target).children('.poi-menu-cell-inactive').show();
			}
		}
	}, {
		key: "onToggleOverview",
		value: function onToggleOverview() {

			viewer.overview.toggleVisibility();
		}
	}, {
		key: "showUsageInstructions",
		value: function showUsageInstructions(id, fadeDuration, fadeOutDelay) {

			if (fadeDuration === undefined) fadeDuration = 2000;
			if (fadeOutDelay === undefined) fadeOutDelay = 2000;

			var ins = $(id);

			if (ins.is(':animated')) {
				return;
			}

			ins.css("opacity", "0.0");
			ins.show();
			ins.animate({ opacity: 1.0 }, fadeDuration, function () {
				$(this).delay(fadeOutDelay);
				ins.animate({ opacity: 0.0 }, fadeDuration);
			});
		}
	}, {
		key: "updateVisibility",
		value: function updateVisibility() {

			if (viewer.isMobile) {
				$("#vr-icon").show();
				if (AppTools.hasFullScreenSupport()) {
					$("#fullscreen-icon").show();
				}
			} else {
				$('#poi-menu').show();
			}
		}
	}, {
		key: "showElement",
		value: function showElement(element, visible) {

			if (visible) {
				$(element).show();
			} else {
				$(element).hide();
			}
		}
	}, {
		key: "showSceneSelection",
		value: function showSceneSelection(visible) {

			this.showElement("#scene-menu-container", visible);
		}
	}, {
		key: "showLogo",
		value: function showLogo(visible) {

			this.showElement("#logo", visible);
		}
	}, {
		key: "showInfo",
		value: function showInfo(visible) {

			this.showElement("#info-text", visible);
		}
	}, {
		key: "populateSceneInfo",
		value: function populateSceneInfo(header, subtext) {

			var animSpeed = 500;
			var overlayOpacity = 0.75;

			if (!viewer.isMobile) {
				$("#info-text").show();
				$("#info-headline").text(header);
				$("#info-subtext").text(subtext);
			} else {
				$("#info-text").show();
				$("#info-headline").text(header);
				$("#info-modal-content").text(subtext);
				$("#info-icon").show();

				if (viewer.initialLoad) {
					$("#info-icon").on("click", function () {
						var target = $("#info-modal-overlay");
						$(target).show();
						$(target).css("opacity", "0.0");
						$(target).animate({ opacity: overlayOpacity, easing: "swing" }, animSpeed);
					});

					$("#info-modal-overlay").on("click", function () {
						$(this).css('opacity', overlayOpacity);
						$(this).animate({ opacity: 0.0, easing: "swing" }, animSpeed, function () {
							$(this).hide();
						});
					});
				}
				if (viewer.isStereoMode) {
					this.showInfo(false);
				}

				this.createParentSiteLink(true);
			}
		}
	}, {
		key: "populateSceneSelection",
		value: function populateSceneSelection() {

			var scenes = sceneCollection.getAllScenes();
			var container = $("#bottom-ui-panel");
			var menuContainer = "#scene-menu-container";

			container.append($("<div id='scene-menu-container'></div>").addClass("scene-selection-container"));

			// move the menu to the bottom on mobile
			if (viewer.isMobile) {
				container.css("bottom", "0");
				$(menuContainer).css("margin-left", "0px");
			} else {
				// add the home button on desktop
				var elm = $(menuContainer).append($("<div><div class='scene-selection-cell-label-wrapper'>&nbsp;</div></div>").addClass("scene-selection-cell").addClass("home-button").click(this.onToggleOverview).css('background-image', "url('images/home_button.png')"));
			}

			// add the scene selection buttons
			for (var i = 0; i < scenes.length; i++) {
				$(menuContainer).append($("<div><div class='scene-selection-cell-label-wrapper'><span class='scene-selection-cell-label'>" + scenes[i].name + "</span></div></div>").addClass("scene-selection-cell").click({ sceneName: scenes[i].name }, function (e) {
					viewer.loadScene(e);
				}).append($("<div class='scene-selection-cell-bg'></div>").css('background-image', "url('" + scenes[i].previewImage + "')")).append($("<div class='scene-selection-cell-overlay'></div>").data("scene", scenes[i].name)));
			}

			if (!viewer.isMobile) {
				this.createParentSiteLink(false);
			}
		}
	}, {
		key: "createParentSiteLink",
		value: function createParentSiteLink() {
			var isMobile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;


			var buttonLabel = "TIL PROJEKTSIDEN";
			var targetURL = "http://cphhighline.dk/#sec9";
			var mobileHeaderText = "FORTSÆT 3D RUNDTUR";
			var mobileSuffixText = "(afslut 3D rundtur)";

			if (isMobile) {

				var container = $("#info-modal-content");
				container.append($("<p class='site-link-mobile'>" + mobileHeaderText + "</p><br>")).append($("<p><a class='site-link-mobile-border' href='" + targetURL + "'' id='site-link-container' target='_blank'>" + buttonLabel + "</a></p>").append($("<p>" + mobileSuffixText + "</p>")));
			} else {

				var _container = $("#bottom-ui-panel");
				_container.append($("<a href='" + targetURL + "'' id='site-link-container' target='_blank'></a>").addClass("site-link-container").addClass("scale"));

				$('#site-link-container').append($("<div>" + buttonLabel + "</div>").addClass("site-link-cell").append($("<div class='site-link-cell-bg'></div>")).append($("<div class='site-link-cell-overlay'></div>")));
			}
		}
	}, {
		key: "selectActiveScene",
		value: function selectActiveScene(target) {

			var targetClass = "scene-selection-cell-overlay";
			var activeClass = "scene-selection-cell-overlay-active";

			// remove selected objects
			$(".scene-selection-cell-overlay").each(function (index) {
				$(this).removeClass(activeClass);
			});

			// check if event originated from the parent
			if (!target.hasClass(targetClass)) {
				target = $(target).children('.' + targetClass);
			}

			target.addClass(activeClass);
			target.css("opacity", "0.0");
			target.animate({ opacity: 1.0, easing: "swing" }, 500);
		}
	}, {
		key: "selectActiveSceneByName",
		value: function selectActiveSceneByName(sceneName) {

			var targetClass = "scene-selection-cell-overlay";
			var target = null;

			$(".scene-selection-cell-overlay").each(function (index) {

				if ($(this).data("scene").toLowerCase() === sceneName.toLowerCase()) {
					target = $(this);
				}
			});

			this.selectActiveScene(target);
		}
	}, {
		key: "showMainUI",
		value: function showMainUI(visible) {

			var target = $("#ui-outer");

			if (visible) {
				target.css("opacity", "0.0");
				target.animate({ opacity: 1.0, easing: "swing" }, 1000);
				$(target).show();
			} else {
				target.css("opacity", "1.0");
				$(target).hide();
			}
		}
	}, {
		key: "createLoadingSpinner",
		value: function createLoadingSpinner() {

			var opts = {
				lines: 13 // The number of lines to draw
				, length: 28 // The length of each line
				, width: 14 // The line thickness
				, radius: 42 // The radius of the inner circle
				, scale: 0.25 // Scales overall size of the spinner
				, corners: 1 // Corner roundness (0..1)
				, color: '#ffffff' // #rgb or #rrggbb or array of colors
				, opacity: 0.25 // Opacity of the lines
				, rotate: 0 // The rotation offset
				, direction: 1 // 1: clockwise, -1: counterclockwise
				, speed: 1 // Rounds per second
				, trail: 60 // Afterglow percentage
				, fps: 20 // Frames per second when using setTimeout() as a fallback for CSS
				, zIndex: 2e9 // The z-index (defaults to 2000000000)
				, className: 'spinner' // The CSS class to assign to the spinner
				, top: '50%' // Top position relative to parent
				, left: '50%' // Left position relative to parent
				, shadow: false // Whether to render a shadow
				, hwaccel: false // Whether to use hardware acceleration
				, position: 'absolute' // Element positioning
			};

			viewer.spinner = new Spinner(opts);
		}
	}, {
		key: "showLoadingSpinner",
		value: function showLoadingSpinner(visible) {

			if (viewer.spinner === null) {
				this.createLoadingSpinner();
			}

			var target = document.getElementById("loading-spinner-dynamic");

			if (visible) {
				$(target).show();
				viewer.spinner.spin(target);
			} else {
				$(target).hide();
				viewer.spinner.stop();
			}

			viewer.isLoading = visible;
		}
	}, {
		key: "mobileCSSRules",
		value: function mobileCSSRules() {

			var baseClasses = ["logo", "headline", "top-text", "ui-panel"];

			for (var i = 0; i < baseClasses.length; i++) {
				//remove default scaling based on media queries
				$("." + baseClasses[i]).removeClass("scale");
				// set specific mobile rules
				$("." + baseClasses[i]).addClass("mobile");
			}
		}
	}]);

	return ViewerUI;
}();

"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Viewer = function () {
	function Viewer() {
		_classCallCheck(this, Viewer);

		this.camera = null;
		this.scene = null;
		this.renderer = null;
		this.stereoEffect = null;
		this.deviceOrientationControls = null;
		this.mainMesh = null;
		this.rightEyeMesh = null;
		this.spinner = null;
		this.clock = null;

		this.defaultFov = 75.0;
		this.minFov = 45.0;
		this.maxFov = 90.0;

		this.isMobile = false;
		this.allowZoom = false;
		this.isStereoMode = false;
		this.isLoading = false;
		this.isFullScreen = false;
		this.initialLoad = true;
		this.manualCameraControl = false;
		this.debug = false;

		this.isUserInteracting = false;
		this.onMouseDownMouseX = 0;
		this.onMouseDownMouseY = 0;
		this.lon = 0;
		this.onMouseDownLon = 0;
		this.lat = 0;
		this.onMouseDownLat = 0;
		this.phi = 0;
		this.theta = 0;

		this.DisplayMode = Object.freeze({ "normal": 1, "stereo": 2 });
		this.FadeDirection = Object.freeze({ "in": 1, "out": 2 });
		this.poiVisibilityState = new POIVisibilityState();
		this.overview = null;
		this.portalController = null;
	}

	_createClass(Viewer, [{
		key: "onWebFontsLoaded",
		value: function onWebFontsLoaded() {

			this.init();
			this.animate();
		}
	}, {
		key: "onWebFontsLoadFailed",
		value: function onWebFontsLoadFailed() {
			// TODO: init anyway using fallback fonts

			if (this.debug) {
				console.log("Error: Unable to load webfonts");
			}
		}
	}, {
		key: "init",
		value: function init() {
			var _this = this;

			this.clock = new THREE.Clock();

			this.isMobile = AppTools.isMobileDevice();

			if (!this.isMobile) {
				this.overview = new Overview();
			}

			var container;

			container = document.getElementById('container');

			this.camera = new THREE.PerspectiveCamera(this.defaultFov, window.innerWidth / window.innerHeight, 1, 1100);
			this.camera.rotation.order = "YZX";
			//camera = new THREE.PerspectiveCamera(90, window.innerWidth / window.innerHeight, 0.001, 700);
			this.camera.target = new THREE.Vector3(0, 0, 0);

			this.scene = new THREE.Scene();
			this.scene.add(this.camera);

			var mainGeometry = new THREE.SphereGeometry(500, 60, 40);
			mainGeometry.scale(-1, 1, 1);

			var mainMaterial = new THREE.MeshBasicMaterial();
			this.mainMesh = new THREE.Mesh(mainGeometry, mainMaterial);
			this.scene.add(this.mainMesh);
			this.mainMesh.visible = false;
			TweenHelpers.trackOriginalOpacities(this.mainMesh);

			// only enable stereo mode on mobile
			if (this.isMobile) {
				// create the geometry used for the right eye
				var rightEyeGeometry = new THREE.SphereGeometry(500, 60, 40);
				rightEyeGeometry.scale(-1, 1, 1);

				var rightEyeMaterial = new THREE.MeshBasicMaterial();

				this.rightEyeMesh = new THREE.Mesh(rightEyeGeometry, rightEyeMaterial);
				this.scene.add(this.rightEyeMesh);
				this.rightEyeMesh.visible = false;
				TweenHelpers.trackOriginalOpacities(this.rightEyeMesh);
			}

			this.renderer = new THREE.WebGLRenderer();
			this.renderer.setPixelRatio(window.devicePixelRatio);
			this.renderer.setSize(window.innerWidth, window.innerHeight);
			container.appendChild(this.renderer.domElement);

			if (!this.isMobile) {

				document.addEventListener('mousedown', function (e) {
					_this.onDocumentMouseDown(e);
				}, false);
				document.addEventListener('mousemove', function (e) {
					_this.onDocumentMouseMove(e);
				}, false);
				document.addEventListener('mouseup', function (e) {
					_this.onDocumentMouseUp(e);
				}, false);
				document.addEventListener('wheel', function (e) {
					_this.onDocumentMouseWheel(e);
				}, false);
			} else {

				window.addEventListener('deviceorientation', function (e) {
					_this.setOrientationControls(e);
				}, true);
			}

			// prevent pinch-zoom
			document.addEventListener('touchmove', function (event) {
				if (event.scale !== 1) {
					event.preventDefault();
				}
			}, false);

			window.addEventListener('resize', function (e) {
				_this.onWindowResize(e);
			}, false);

			var self = this;

			THREE.DefaultLoadingManager.onLoad = function () {
				self.onThreeJSLoad();
			};

			THREE.DefaultLoadingManager.onProgress = function (url, itemsLoaded, itemsTotal) {
				self.onLoadProgress(url, itemsLoaded, itemsTotal);
			};

			if (this.isMobile) {
				this.deviceOrientationControls = new THREE.DeviceOrientationControls(this.camera, true);
				this.deviceOrientationControls.connect();
				this.stereoEffect = new THREE.StereoEffect(this.renderer);
			}

			this.portalController = new PortalController();

			// finally, load the default scene
			this.loadDefaultScene();
		}
	}, {
		key: "loadDefaultScene",
		value: function loadDefaultScene() {

			var defaultScene = sceneCollection.getDefaultScene().name;
			var queryParam = AppTools.getUrlParameterByName("scene");

			if (typeof queryParam === "string") {
				if (sceneCollection.isValidScene(queryParam)) {
					defaultScene = queryParam;
				}
			}

			this.loadScene(null, defaultScene);
		}
	}, {
		key: "unloadPreviousScene",
		value: function unloadPreviousScene() {

			this.clearAllSprites();
		}
	}, {
		key: "fadeScene",
		value: function fadeScene(fadeDirection) {

			var dir = fadeDirection === this.FadeDirection.in ? "in" : "out";
			var opacity = fadeDirection === this.FadeDirection.in ? 0.0 : 1.0;
			var duration = 1000.0;

			viewer.mainMesh.material.opacity = opacity;
			TweenHelpers.fadeMesh(viewer.mainMesh, dir, { duration: duration });
		}
	}, {
		key: "loadScene",
		value: function loadScene(event) {
			var manualSceneName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;


			viewerUI.showLoadingSpinner(true);
			viewer.isLoading = true;

			this.unloadPreviousScene();

			var sceneName = manualSceneName != null ? manualSceneName : event.data.sceneName;
			var sceneData = sceneCollection.getSceneByName(sceneName);

			sceneCollection.setActiveScene(sceneName);

			// load and assign textures to the sphere geometry meshes

			// deallocate the previous map
			if (this.mainMesh.material.map != null) {
				this.mainMesh.material.map.dispose();
			}

			this.mainMesh.material.map = new THREE.TextureLoader().load(sceneData.leftEyeImage);
			this.mainMesh.material.needsUpdate = true;

			if (this.isMobile) {

				// deallocate the previous map
				if (this.rightEyeMesh.material.map != null) {
					this.rightEyeMesh.material.map.dispose();
				}

				this.rightEyeMesh.material.map = new THREE.TextureLoader().load(sceneData.rightEyeImage);
				this.rightEyeMesh.material.needsUpdate = true;
			}
			// assign UI labels
			viewerUI.populateSceneInfo(sceneData.headline, sceneData.description);

			// handle UI selection
			if (event != null) {
				viewerUI.selectActiveScene($(event.target));
			}

			// set starting lon/lat
			this.lat = sceneData.startLat;
			this.lon = sceneData.startLon;
		}
	}, {
		key: "switchRenderMode",
		value: function switchRenderMode(displayMode) {

			if (displayMode === this.DisplayMode.stereo) {

				this.isStereoMode = true;
				this.mainMesh.layers.set(1);
				this.rightEyeMesh.layers.set(2);
				viewerUI.showSceneSelection(false);
				viewerUI.showLogo(false);
				viewerUI.showInfo(false);
			} else {

				this.isStereoMode = false;
				this.mainMesh.layers.set(0);
				viewerUI.showSceneSelection(true);
				viewerUI.showLogo(true);
				viewerUI.showInfo(true);
			}

			// update mesh states
			this.updateMeshVisibility();
			// force redraw
			this.onWindowResize();
		}
	}, {
		key: "onWindowResize",
		value: function onWindowResize(event) {

			this.camera.aspect = window.innerWidth / window.innerHeight;
			this.camera.updateProjectionMatrix();

			this.renderer.setSize(window.innerWidth, window.innerHeight);

			if (!this.isMobile) {
				this.overview.placeOverview();
			}
		}
	}, {
		key: "onDocumentMouseDown",
		value: function onDocumentMouseDown(event) {

			event.preventDefault();

			this.isUserInteracting = true;

			this.onPointerDownPointerX = event.clientX;
			this.onPointerDownPointerY = event.clientY;

			this.onPointerDownLon = this.lon;
			this.onPointerDownLat = this.lat;
		}
	}, {
		key: "onDocumentMouseMove",
		value: function onDocumentMouseMove(event) {

			if (this.isUserInteracting === true) {

				this.lon = (this.onPointerDownPointerX - event.clientX) * 0.1 + this.onPointerDownLon;
				this.lat = (event.clientY - this.onPointerDownPointerY) * 0.1 + this.onPointerDownLat;
			}
		}
	}, {
		key: "onDocumentMouseUp",
		value: function onDocumentMouseUp(event) {

			this.isUserInteracting = false;
		}
	}, {
		key: "onDocumentMouseWheel",
		value: function onDocumentMouseWheel(event) {

			if (!this.allowZoom) {
				return;
			}

			this.setFOV(AppTools.clamp(this.camera.fov += event.deltaY * 0.05, this.minFov, this.maxFov));
		}
	}, {
		key: "animate",
		value: function animate() {

			requestAnimationFrame(this.animate.bind(this));
			TWEEN.update();
			this.update();
		}
	}, {
		key: "setFov",
		value: function setFov(value) {

			this.camera.fov = value;
			this.camera.updateProjectionMatrix();
		}
	}, {
		key: "setDefaultFov",
		value: function setDefaultFov() {

			this.setFov(this.defaultFov);
		}
	}, {
		key: "setOrientationControls",
		value: function setOrientationControls(e) {

			if (!e.alpha) {
				return;
			}
		}
	}, {
		key: "createPOISprite",
		value: function createPOISprite(cameraPos, intersectionPos, spriteScale, spriteTint, spriteDistPercentage, headerText, subText) {
			var visible = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : true;


			// calculate positioning
			var startPos = cameraPos;
			var direction = new THREE.Vector3();
			direction.subVectors(intersectionPos, startPos);

			var finalPos = new THREE.Vector3();
			finalPos.addVectors(startPos, direction.multiplyScalar(spriteDistPercentage));

			// insert sprite labels
			var fontSize = 50;
			var headerFontFamily = "SkanskaSansProRegular";
			var subtextFontFamily = "SkanskaSansProBold";

			var canvas = document.createElement('canvas');
			var context = canvas.getContext('2d');
			var innerImageHeight = 256;

			context.canvas.width = 512;
			context.canvas.height = 512;

			context.lineWidth = 2;

			context.font = fontSize + "px " + headerFontFamily;
			var headerMetrics = context.measureText(headerText);
			var headerTextWidth = headerMetrics.width;
			context.fillText(headerText, context.canvas.width * 0.5 - headerTextWidth * 0.5, context.canvas.height * 0.5 + fontSize);

			context.font = fontSize + "px " + subtextFontFamily;
			var subTextMetrics = context.measureText(subText);
			var subTextWidth = subTextMetrics.width;
			context.fillText(subText, context.canvas.width * 0.5 - subTextWidth * 0.5, context.canvas.height * 0.5 + fontSize * 2.5);

			if (this.debug) {
				context.fillStyle = "rgba(1.0, 0.0, 0.0, 0.5)";
				context.fillRect(0, 0, context.canvas.width, context.canvas.height);
			}

			// canvas contents will be used as a texture
			var texture = new THREE.Texture(canvas);
			texture.needsUpdate = true;

			// create the sprite and position it
			var spriteMaterial = new THREE.SpriteMaterial({ map: texture, color: spriteTint });
			var sprite = new THREE.Sprite(spriteMaterial);
			sprite.scale.set(spriteScale, spriteScale, spriteScale);
			sprite.position.set(finalPos.x, finalPos.y, finalPos.z);

			// fit the image into the texture size and add the sprite to the scene
			var spriteImage = new Image();
			spriteImage.src = 'textures/poi_sprite_greyscale.png';

			var self = this;
			spriteImage.onload = function () {
				context.drawImage(spriteImage, context.canvas.width * 0.5 - spriteImage.width * 0.5, 0, spriteImage.width, spriteImage.height);
				self.scene.add(sprite);
				sprite.visible = visible;
			};

			return sprite;
		}
	}, {
		key: "insertPOIDataFromJSON",
		value: function insertPOIDataFromJSON(jsonObject) {

			var dataset = jsonObject.dataset;
			var disabledTags = this.poiVisibilityState.getDisabledTags();
			var visible = true;

			for (var i = 0; i < dataset.length; i++) {

				var intersectionPoint = new THREE.Vector3(dataset[i].intersectionPoint.x, dataset[i].intersectionPoint.y, dataset[i].intersectionPoint.z);
				var header = dataset[i].headerText;
				var sub = dataset[i].subText;
				var scale = dataset[i].scale;
				var color = dataset[i].color;
				var distPercentage = dataset[i].distPercentage;
				var categoryTag = dataset[i].categoryTag;

				// if not filtered, mark it as enabled
				if (disabledTags.indexOf(categoryTag.toLowerCase()) === -1) {
					this.poiVisibilityState.setTagState(categoryTag, true);
					visible = true;
				} else {
					visible = false;
				}

				var sprite = this.createPOISprite(this.camera.position, intersectionPoint, scale, color, distPercentage, header, sub, visible);
				this.addPOISpriteMetaData(sprite, intersectionPoint, scale, color, distPercentage, header, sub, categoryTag);
			}
		}
	}, {
		key: "togglePOIByCategory",
		value: function togglePOIByCategory(categoryTag, visibilityFlag) {

			var categoryFilter = categoryTag.toLowerCase();

			this.scene.traverse(function (object) {

				if (object instanceof THREE.Sprite) {
					if (object.meta != undefined) {
						if (object.meta.categoryTag.toLowerCase() === categoryFilter) {
							object.visible = visibilityFlag;
						}
					}
				}
			});
		}
	}, {
		key: "addPOISpriteMetaData",
		value: function addPOISpriteMetaData(sprite, intersectionPoint, scale, color, distPerc, header, sub, categoryTag) {

			sprite.meta = {};
			sprite.meta.intersectionPoint = intersectionPoint;
			sprite.meta.scale = scale;
			sprite.meta.color = color;
			sprite.meta.distPercentage = distPerc;
			sprite.meta.headerText = header;
			sprite.meta.subText = sub;
			sprite.meta.categoryTag = categoryTag;
		}
	}, {
		key: "clearAllSprites",
		value: function clearAllSprites() {

			var objectsToRemove = [];

			// find the target objects
			this.scene.traverse(function (object) {
				if (object instanceof THREE.Sprite) {
					objectsToRemove.push(object);
				}
			});

			// remove the targets
			for (var i = 0; i < objectsToRemove.length; i++) {
				this.scene.remove(objectsToRemove[i]);
			}
		}
	}, {
		key: "scalePOISprites",
		value: function scalePOISprites(uniformScaleFactor) {

			var sf = uniformScaleFactor;

			this.scene.traverse(function (object) {
				if (object instanceof THREE.Sprite) {
					object.scale.set(object.scale.x * sf, object.scale.y * sf, object.scale.z * sf);
				}
			});
		}
	}, {
		key: "scalePOISpritesByFov",
		value: function scalePOISpritesByFov() {

			// TODO:
			// current fov
			// fov diff from default as a factor

			this.scene.traverse(function (object) {
				if (object instanceof THREE.Sprite) {
					//object.scale.set(camera.fov * );
				}
			});
		}
	}, {
		key: "updateMeshVisibility",
		value: function updateMeshVisibility() {

			if (this.isMobile) {

				if (this.isStereoMode) {
					this.mainMesh.visible = true;
					this.rightEyeMesh.visible = true;
				} else {
					this.mainMesh.visible = true;
					this.rightEyeMesh.visible = false;
				}
			} else {
				this.mainMesh.visible = true;
			}
		}
	}, {
		key: "updatePOIData",
		value: function updatePOIData() {

			var activeScene = sceneCollection.getActiveScene();

			if (!this.isMobile && activeScene.poiData != null) {
				this.insertPOIDataFromJSON(activeScene.poiData);
			}
		}
	}, {
		key: "updatePOIVisibility",
		value: function updatePOIVisibility() {

			var disabledTags = this.poiVisibilityState.getDisabledTags();

			for (var i = 0; i < disabledTags.length; i++) {
				this.togglePOIByCategory(disabledTags[i], false);
			}
		}
	}, {
		key: "onThreeJSLoad",
		value: function onThreeJSLoad() {

			viewerUI.showLoadingSpinner(false);

			if (!viewer.isMobile) {
				this.fadeScene(this.FadeDirection.in);
			}

			if (this.initialLoad) {
				viewerUI.populateSceneSelection();
				viewerUI.showMainUI(true);
				viewerUI.selectActiveSceneByName(sceneCollection.getActiveSceneName());

				if (!this.isMobile) {
					viewerUI.showUsageInstructions("#instruction-overlay-desktop");
				} else {
					viewerUI.mobileCSSRules();
					viewerUI.showUsageInstructions("#instruction-overlay-mobile");
				}

				this.initialLoad = false;
			}

			this.updatePOIData();
			this.portalController.updatePortalData();
			this.updateMeshVisibility();
			viewerUI.updateVisibility();

			viewer.isLoading = false;
		}
	}, {
		key: "onLoadProgress",
		value: function onLoadProgress(url, itemsLoaded, itemsTotal) {

			if (this.debug) {
				console.log('Loading file: ' + url + '.\nLoaded ' + itemsLoaded + ' of ' + itemsTotal + ' files.');
			}
		}
	}, {
		key: "update",
		value: function update() {

			if (this.isMobile) {

				this.deviceOrientationControls.update();

				if (this.isStereoMode) {
					this.stereoEffect.render(this.scene, this.camera);
				} else {
					this.renderer.render(this.scene, this.camera);
				}
			} else {

				if (!this.manualCameraControl) {

					this.lat = Math.max(-85, Math.min(85, this.lat));
					this.phi = THREE.Math.degToRad(90 - this.lat);
					this.theta = THREE.Math.degToRad(this.lon);

					this.camera.target.x = 500 * Math.sin(this.phi) * Math.cos(this.theta);
					this.camera.target.y = 500 * Math.cos(this.phi);
					this.camera.target.z = 500 * Math.sin(this.phi) * Math.sin(this.theta);

					this.camera.lookAt(this.camera.target);
				}

				this.renderer.render(this.scene, this.camera);
			}

			/*
   // distortion
   camera.position.copy( camera.target ).negate();
   */
		}
	}]);

	return Viewer;
}();

var viewer = new Viewer();
var viewerUI = new ViewerUI();
"use strict";

/* eslint-env browser */
/* global viewer */

window.WebFontConfig = {

	active: function active() {
		"use strict";

		viewer.onWebFontsLoaded();
	},

	inactive: function inactive() {
		"use strict";

		viewer.onWebFontsLoadFailed();
	},

	custom: {
		families: ["SkanskaSansProRegular", "SkanskaSansProBold"],
		urls: ["css/app.css"]
	}
};